import React, { useState } from 'react';
import { Tabs } from 'antd';
import PeopleManagerBudgetAutomation from './PeopleManagerBudgetAutomation';


const AutomateBudget: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Automate Budget Control" key="1">
        <PeopleManagerBudgetAutomation />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default AutomateBudget;